export default "__VITE_ASSET__BctvZnIt__"